import React from "react";

const holder = {
  closeFilterDropdownSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false, pageNumber: 1 });
      document.removeEventListener("mousedown", holder.closeFilterDropdownSelector)
    }
  }
};

export default {
  'FilterDropdown.Wrapper.Header': async ({ isOpen, containerRef, isReadonly, inputRef }, _, internalStateSetter) => {
    if (isReadonly) return;
    await internalStateSetter('isOpen', !isOpen);

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;

    newInputRef?.current?.children?.[0]?.focus?.()
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeFilterDropdownSelector)
    } else {
      document.addEventListener("mousedown", holder.closeFilterDropdownSelector);
    }
  },
  'FilterDropdown.Wrapper.DropdownWrapper.InputWrapper.Input': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchTerm: value, pageNumber: 1 })
  },
  'FilterDropdown.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.Option': ({ id }, outlet, internalStateSetter) => {
    outlet({ selectedOptionId: id });
    internalStateSetter({ isOpen: false });
    document.removeEventListener("mousedown", holder.closeFilterDropdownSelector);
    return;
  },
  'FilterDropdown.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.LoadMore': ({ pageNumber }, _, internalStateSetter) => {
    internalStateSetter({ pageNumber: pageNumber + 1 })
  },
}